/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class SecurityMergeDialog extends SiteEntityDialog<SecurityMergeRow, any> {
        protected getFormKey() { return SecurityMergeForm.formKey; }
        protected getIdProperty() { return SecurityMergeRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergeRow.localTextPrefix; }
        protected getNameProperty() { return SecurityMergeRow.nameProperty; }
        protected getService() { return SecurityMergeService.baseUrl; }

        protected form = new SecurityMergeForm(this.idPrefix);

        constructor(options?: any) {
            super(options);

            this.form.GicsSelection.change(e => {
                SecurityDialog.gicsSetFormValues(this.form, false, null);
            });
           
        }
        
        protected updateInterface() {
            super.updateInterface();

            if (this.entity && this.entity.SecurityId)
                Serenity.EditorUtils.setReadOnly(this.form.SecurityId, true);

            this.cloneButton.hide();
            this.deleteButton.hide();
        }

        loadEntity(entity) {
            super.loadEntity(entity);
            SecurityDialog.gicsLoadEntity(entity, this.form);
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            SecurityDialog.gicsSaveEntity(entity);
            return entity;
        }
    }
}